import React, { useEffect, useState,Fragment } from 'react'
import { Card, Col, Container, Form, Row } from 'react-bootstrap'
import BootstrapTable from 'react-bootstrap-table-next'
import { useDispatch, useSelector } from 'react-redux'
import { validaNumeros, convertirFecha, diaAnterior, diaPosterior, formato_monto, isValidParam } from '../../../common/Formatos'
import { configuracionFormAction8,obtenerCasoImplicado,ObtenerCompanias,obtenerDetalles,obtenerParametroPorciento,obtenerParametros,obtenerRequisitos, ObtenerSeguros  } from '../../../store/actions/encargado-cia-action'
import Requisitos from './Requisitos'
import { Auth, LoadingComponent } from 'recupero-comunes'

const VerificarForm = ({formik, requi, setRequi, setPorConvenioOld,setMirecobro,setMiNeto,seguroError}) => {
  
  const data_encargado_cia = useSelector((state) => state.encargado_compania)

  const { rutUsuario, rutOrganizacion } = Auth.currentUser()
  const { cfg_form, antecedentesCasos,cfg_form8, liquidacionPerdida, casoImplicado, detalles, companias, requisitos, seguros , llaves, parametros,parametrosPorciento} = data_encargado_cia

  const [datosSiniestro, setDatosSiniestro] = useState({})
  const [seguro, setSeguro]=useState("")
  const [compania, setCompania]=useState("")
  const [siniestro, setSiniestro]=useState("")
  const [fechaSiniestro, setFechaSiniestro]=useState("")
  const [fechaSin, setFechaSin]=useState("")
  const [convenio, setConvenio]=useState(0)
  const [convenioOld, setConvenioOld]=useState(0)
  const[montoNeto,setMontoNeto]=useState(0)
  const[recobro,setRecobro]=useState(0)
  const[recobroNoFormato,setRecobroNoFormato]=useState(0)
  const[excepcion,setExcepcion]=useState("")
  const[observaciones,setObservaciones]=useState("")
  const[requisitosValida,setRequisitos]=useState("")
  const[errorSeguro,setErrorSeguro]=useState(false)

  const [loading, setLoading]=useState(false)

  const dispatch = useDispatch();
useEffect(()=>{
  setPorConvenioOld(convenioOld)
  setMirecobro(recobroNoFormato)
  setMiNeto()
},[convenioOld,recobroNoFormato])
  useEffect(() => {   
    let query = Buffer.from(JSON.stringify( {"concepto":"212"})).toString('base64');
    dispatch(ObtenerSeguros(query));   

}, [dispatch]);
  useEffect(() => {   
    let query = Buffer.from(JSON.stringify( {})).toString('base64');
    dispatch(ObtenerCompanias(query));   

}, [dispatch]);
  useEffect(() => {   
    let query = Buffer.from(JSON.stringify({"rutcia":0,"parametro":34})).toString('base64')
      dispatch(obtenerParametros(query))
      .then(()=>{
        let query = Buffer.from(JSON.stringify({"rutcia":0,"parametro":20})).toString('base64')
        dispatch(obtenerParametroPorciento(query))
      })

}, [dispatch]);
  useEffect(()=>{
    setRequisitos(requisitos && requisitos.requisitos)
  },[requisitos])
  useEffect(()=>{
    // Si el caso no tiene liquidación de pérdida registrada, mtoPago llega null — se blinda a 0 en
    // vez de dejar pasar null: montoNeto null hacía que "montoNeto && formato_monto(...)" más abajo
    // devolviera null tal cual (sin blindaje), y ese null llegaba a formik.values.montoRecobro,
    // rompiendo la validación Yup ("montoRecobro must be a `string` type... final value was: `null`").
    setMontoNeto(liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
    ? liquidacionPerdida.liquidacionPerdida['mtoSalvataje']!==null && liquidacionPerdida.liquidacionPerdida['mtoPago']!==null
      ? (parseInt(liquidacionPerdida.liquidacionPerdida['mtoPago']) - parseInt(liquidacionPerdida.liquidacionPerdida['mtoSalvataje']))
      :(liquidacionPerdida.liquidacionPerdida['mtoPago'] || 0)
    : 0)
  },[liquidacionPerdida])

useEffect(()=>{
    setSeguro(casoImplicado && casoImplicado.length !== 'undefined'
    ? casoImplicado.casoImplicado[0]['IdSeguroImplicado']
    : "")
    setCompania(casoImplicado && casoImplicado.length !== 'undefined'
    ?casoImplicado.casoImplicado[0]['IdCiaImplicado']!==null?casoImplicado.casoImplicado[0]['IdCiaImplicado']:1
    : "")
    setSiniestro( casoImplicado && casoImplicado.length !== 'undefined'
    ? (casoImplicado.casoImplicado[0]['SiniestroIM']===null?"":casoImplicado.casoImplicado[0]['SiniestroIM'])
    : "")
    setFechaSiniestro(casoImplicado && casoImplicado.length !== 'undefined'
    ? (casoImplicado.casoImplicado[0]['FechaSiniestroIMFormat']===null?"":convertirFecha(casoImplicado.casoImplicado[0]['FechaSiniestroIMFormat']))
    : "")
    setFechaSin(casoImplicado && casoImplicado.length !== 'undefined'
    ? (casoImplicado.casoImplicado[0]['FechaSiniestroFormat']===null?"":(casoImplicado.casoImplicado[0]['FechaSiniestroFormat']))
    : "")

    if((casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro']===null || casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro']===undefined ) ) { 
      if (parametrosPorciento) {
        //console.log("parametrosPorciento: ", parametrosPorciento);
        setConvenio( parametrosPorciento.parametrosPorciento['valorParametro'])
        setConvenioOld(convenio)
        //setRecobro(montoNeto && formato_monto(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100))
        //setRecobroNoFormato(montoNeto && montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100)
        setRecobro(montoNeto && formato_monto(Math.round(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100)))
        setRecobroNoFormato(montoNeto && Math.round(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100))
      }
    } else {
      if (casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro']!==0) {
        //console.log("MontoRecobro: ", casoImplicado.casoImplicado[0]['MontoRecobro']);
        //setRecobro(casoImplicado && formato_monto(parseInt(casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro'])))
        //setRecobroNoFormato(casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro'])
        setRecobro(casoImplicado && formato_monto(Math.round(casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro'])));
        setRecobroNoFormato(casoImplicado && Math.round(casoImplicado.casoImplicado[0]['MontoRecobro']))
        setConvenio(casoImplicado && parseFloat(casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro']*100/montoNeto).toFixed(0))
        setConvenioOld(casoImplicado && parseFloat(casoImplicado && casoImplicado.casoImplicado[0]['MontoRecobro']*100/montoNeto).toFixed(0))
      } else {
        if (parametrosPorciento ) {
          //console.log("parametrosPorciento 2: ", parametrosPorciento);
          //setRecobro(montoNeto && formato_monto(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100))
          //setRecobroNoFormato(montoNeto && montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100)
          setRecobro(montoNeto && formato_monto(Math.round(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100)));
          setRecobroNoFormato(montoNeto && Math.round(montoNeto*parametrosPorciento.parametrosPorciento['valorParametro']/100))
          setConvenio(parametrosPorciento.parametrosPorciento['valorParametro'])
          setConvenioOld(convenio)
        }
      }
    }
  },[casoImplicado,liquidacionPerdida,montoNeto,parametrosPorciento])

  
useEffect(() => {
   if (llaves){
     let query = Buffer.from(JSON.stringify({ "idImplicado": llaves["idImplicado"], "idCaso": llaves["idCaso"] })).toString('base64');
     dispatch(obtenerCasoImplicado(query));
   }

}, [dispatch, llaves]);
useEffect(() => {
  if (llaves){

    let query = Buffer.from(JSON.stringify({"idCaso":llaves["idCaso"],"gestion":"CC"})).toString('base64');
    dispatch(obtenerRequisitos(query));
    }

}, [dispatch, llaves]);
useEffect(() => {
   
    let query = Buffer.from(JSON.stringify({"concepto":" 234"})).toString('base64');
    dispatch(obtenerDetalles(query));

}, [dispatch]);
const restarFechas=(fechaInicio)=>{    
  const [dia, mes, ano]=fechaInicio.split("-")   
  const fechaFormat=[ano, mes,dia].join("-")     
  const tiempoTranscurrido = Date.now();
  const hoy = new Date(tiempoTranscurrido).getTime(); 
  var diff = hoy - new Date(fechaFormat).getTime();
  return parseInt(diff/(1000*60*60*24));
}
function validaConvenio(event){ 
  var e = event || window.event;
  var key = e.keyCode || e.which;
  if ( key === 110 || key === 190 ) {             
    return true;     
  }     
  if(key==8 || key===46 || key===37 || key===39 || key===9) { // backspace.
    return true;
  } else if(key>=48 && key<=57) { // is a number.
    return true;
  } else if(key>=96 && key<=105) { // is a number.
    return true;
  } else{ // other keys.
    e.preventDefault();   
  } 
}
function recargarRequisitos() {   
  if (llaves){
    let query = Buffer.from(JSON.stringify({"idCaso":llaves["idCaso"],"gestion":"CC"})).toString('base64');
    setLoading(true);
    dispatch(obtenerRequisitos(query));
    setLoading(false);
  }
}
  return (
      <>
    <LoadingComponent show={loading}/>
    <Card className='mt-1 '>
      <Card.Header className='mt-0 mb-0' as='h6' style={{backgroundColor:"#4F517A", color:"white"}} >      
        {cfg_form8 ? cfg_form8.cfg_form8['preparacartacobro-title-verifantec'] : ""}
      </Card.Header>
      <Container>
        {cfg_form8 ? (
          <div>
          <Row className='mb-3'>
          <Col md="2">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 &&
                      cfg_form8.cfg_form8['preparacartacobro-lbl-estadorec']}
                  </Form.Label>
                  <br />
                  <Form.Text className='mb-3'>
                  {casoImplicado && casoImplicado.length !== 'undefined'
                    ? casoImplicado.casoImplicado[0]['EstadoImplicado']
                    : ""}
                </Form.Text>
                </Col>
                <Col md="3">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-cmb-seguro']}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)                       
                        
                        setSeguro(e.target.value)
                       
                        
                        }}
                    name='seguroIM'
                   
                    value={formik.values.seguroIM =seguro          
                    }
                    error={formik.errors.seguroIM} 
                  >
                  <option value={""}>Seleccione...</option>
                  {
                      seguros && seguros.seguros.map(c=>(
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))
                    }
                  </Form.Select>
                  {formik.errors.seguroIM? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.seguroIM}</Form.Text>) :""}
                </Col>
                <Col md="3">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-cmb-cia']}
                  </Form.Label>
                  <br />
                  <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setCompania(e.target.value)
                        }}
                    name='idCompaniaIM'
                   
                    value={formik.values.idCompaniaIM =compania          
                    }
                    error={formik.errors.idCompaniaIM}
                  >
                   <option value={""}>Seleccione...</option>
                    {
                      companias && companias.companias.map(c=>(
                        <option key={c.id} value={c.id}>{c.nombre}</option>
                      ))
                    }
                    
                  </Form.Select>
                  {formik.errors.idCompaniaIM? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.idCompaniaIM}</Form.Text>) :""}
                </Col>
                <Col md="2">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 &&
                      cfg_form8.cfg_form8['preparacartacobro-input-siniestroimpl']}
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setSiniestro(e.target.value)
                        }}
                    name='idSiniestroIM'
                   
                    value={formik.values.idSiniestroIM =siniestro          
                    }
                    error={formik.errors.idSiniestroIM}
                  ></Form.Control>
                  {formik.errors.idSiniestroIM? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.idSiniestroIM}</Form.Text>) :""}
                </Col>
                <Col md="2">
                  <Form.Label
                    className='mt-3 mb-0'
                    style={{ fontWeight: 'bold', fontSize: '14px' }}
                  >
                    {cfg_form8 &&
                      cfg_form8.cfg_form8['preparacartacobro-input-fechasinimpl']}
                  </Form.Label>
                  <br />
                  <Form.Control
                    className='mt-2'
                    aria-label='Default select example'
                    type="date"
                    min={ fechaSin && parametros && diaAnterior(fechaSin, parametros.parametros['valorParametro'])}
                    max={ fechaSin &&  parametros && diaPosterior(fechaSin, parametros.parametros['valorParametro'])}
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setFechaSiniestro(e.target.value)
                        }}
                    name='fechaSiniestroIM'
                   
                    value={formik.values.fechaSiniestroIM =fechaSiniestro          
                    }
                    //error={formik.errors.fechaSiniestroIM} 
                   
                  ></Form.Control>
                  {/*{formik.errors.fechaSiniestroIM ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.fechaSiniestroIM}</Form.Text>) :""}*/}
                </Col>
              </Row>
            <Row>
              <Col md="2">
                <Form.Label
                  className='mb-0 mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-diascarta']}
                </Form.Label>{' '}
                <br />
                <Form.Text className='mb-3'>
                  {antecedentesCasos && antecedentesCasos.length !== 'undefined'
                    ? restarFechas((antecedentesCasos.antecedentesCasos[0]["FechaSiniestroFormat"]))
                    : ""}
                </Form.Text>
              </Col>
              <Col md="3">
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8 ['preparacartacobro-cmb-moneda']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                  {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                    ? liquidacionPerdida.liquidacionPerdida['glosaMonedaPago']
                    : ""}
                </Form.Text>
               
                
              </Col>
              <Col md="3">
                <Form.Label className=' mb-0  mt-2'style={{ fontWeight: 'bold', fontSize: '14px' }}>
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-mtoneto']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3'>
                  {liquidacionPerdida && liquidacionPerdida.length !== 'undefined'
                    ? isValidParam(liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])
                      ? formato_monto(parseInt(liquidacionPerdida.liquidacionPerdida['mtoPago'] - liquidacionPerdida.liquidacionPerdida['mtoSalvataje'])) 
                      : formato_monto(liquidacionPerdida.liquidacionPerdida['mtoPago'])
                    : ""}
                </Form.Text>
                
              </Col>
              

              <Col md="2">
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-porcconvenio']}
                </Form.Label>
                <br />
                <Form.Control
                    className='mt-2'
                    aria-label='Default select example'                    
                    onKeyDown={e=>validaConvenio(e)}
                    type="number"
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setConvenio(e.target.value)
                        if (montoNeto !== "" && montoNeto !==null && montoNeto !==undefined){
                          setRecobro(liquidacionPerdida && (liquidacionPerdida.liquidacionPerdida['codMonedaPago'])===30001?formato_monto(Math.round(montoNeto*e.target.value/100)):parseFloat(montoNeto*e.target.value/100).toFixed(2))
                          setRecobroNoFormato(liquidacionPerdida && (liquidacionPerdida.liquidacionPerdida['codMonedaPago'])===30001?Math.round(montoNeto*e.target.value/100):parseFloat(montoNeto*e.target.value/100).toFixed(2))
                        }else{setRecobro(0)}
                        // setRecobro(liquidacionPerdida && (liquidacionPerdida.liquidacionPerdida['codMonedaPago'])===30001
                        // ?(montoNeto !=="" && montoNeto!==null && montoNeto!==undefined ?formato_monto(montoNeto*e.target.value/100)?0):(montoNeto !=="" && montoNeto!==null && montoNeto!==undefined ? formato_monto(parseFloat(montoNeto*e.target.value/100).toFixed(2)):0))                        
                        // setRecobroNoFormato(liquidacionPerdida &&(liquidacionPerdida.liquidacionPerdida['codMonedaPago'])===30001?parseInt(montoNeto*e.target.value/100):parseFloat(montoNeto*e.target.value/100).toFixed(2))                        
                         }}
                     onBlur={()=>{                 
                      if(convenio!==""){

                       setConvenio(parseFloat(convenio).toFixed(2).split(".")[1]==="00"?convenio:parseFloat(convenio).toFixed(2))
                       }   
                       else{
                         setConvenio("")
                       }
                      } }
                       
                       
                    name='porcConvenio'
                   
                    value={formik.values.porcConvenio =convenio  
                    }
                      error={formik.errors.porcConvenio}        
                  ></Form.Control>
                  {formik.errors.porcConvenio ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.porcConvenio}</Form.Text>) :""}
              </Col>
              <Col md="2">
                <Form.Label
                  className='mb-0  mt-2'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}

                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-mtorecobro']}
                </Form.Label>
                <br />
                <Form.Control
                    className='mt-2'
                    aria-label='Default select example'
                    onKeyDown={e=>validaNumeros(e)}
                    onBlur={()=>setRecobro(liquidacionPerdida && (liquidacionPerdida.liquidacionPerdida['codMonedaPago'])===30001?formato_monto(Math.round(recobro)):parseFloat(recobro).toFixed(2))}
                    onFocus={()=>setRecobro(recobroNoFormato)}
                    onChange={e=>{                    
                        formik.handleChange(e)
                        setRecobro(e.target.value)
                        setRecobroNoFormato(e.target.value)
                        if (montoNeto !== "" && montoNeto !==null && montoNeto !==undefined){                          
                          setConvenio(parseFloat(e.target.value*100/montoNeto).toFixed(2))
                        } else {
                          setConvenio(0)
                        }
                        }}
                    name='montoRecobro'                   
                    value={formik.values.montoRecobro=recobro}
                    error={formik.errors.montoRecobro} 
                  ></Form.Control>
                  {formik.errors.montoRecobro ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.montoRecobro}</Form.Text>) :""}
              </Col>
            
            </Row>
            <Row >
            <Col md="5" >
              <Requisitos 
                req={requisitosValida && requisitosValida} 
                requi={requi} 
                setRequi={setRequi}
                recargarRequisitos={recargarRequisitos}
              />

            </Col>
              <Col md="3">
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-cmb-motivoexcep']}
                </Form.Label>
                <br />
                <Form.Select
                    className='mt-2'
                    aria-label='Default select example'
                    onChange={e=>{                    
                        formik.handleChange(e)
                       setExcepcion(e.target.value)
                        
                        }}
                    name='motivoExcepcion'
                   
                    value={formik.values.motivoExcepcion =excepcion          
                    }
                  ><option value="1">Seleccionar...</option>
                    {detalles && detalles.detalles.map(d=>(
                      <option key={d.id} value={d.id}>{d.nombre}</option>
                    ))}
                  </Form.Select>
              </Col>
              <Col md="4">
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-input-obsmotivo']}
                </Form.Label>
                <br />
                <Form.Control as="textarea" rows={3} 
                      onChange={e=>{                    
                        formik.handleChange(e)
                       setObservaciones(e.target.value)
                        
                        }}
                    name='observaciones'
                   
                    value={formik.values.observaciones =observaciones          
                    }
                    error={formik.errors.observaciones}  

                />
                 {formik.errors.observaciones ? (<Form.Text variant="danger" style={{color:"red"}} >{formik.errors.observaciones}</Form.Text>) :""}
              </Col>

             
              
            </Row>
            <Row className="mb-3" >
            <Col md="5"></Col>
            <Col >
                <Form.Label
                  className='mt-3 mb-0'
                  style={{ fontWeight: 'bold', fontSize: '14px' }}
                >
                  {cfg_form8 && cfg_form8.cfg_form8['preparacartacobro-lbl-destinatario']}
                </Form.Label>
                <br />
                <Form.Text className='mb-3' style={{ fontSize: '14px' }}>
               
                {casoImplicado && casoImplicado.length !== 'undefined'
                    ? casoImplicado.casoImplicado[0]['DestinatarioCIA']: ""}
                </Form.Text>
                <Form.Text className='mb-' style={{ fontSize: '14px', marginLeft:'50px' }}>
               
               {casoImplicado && casoImplicado.length !== 'undefined'
                   ? casoImplicado.casoImplicado[0]['EmailDestinatarioCIA']: ""}
               </Form.Text>
              </Col>
           

             
              
            </Row>
            
           
          </div>
        ) : ""}
      </Container>
    </Card>


    </>
  )
}

export default VerificarForm


